export const SET_FLOWS_DUE_WIDGET_RESULTS = 'SET_FLOWS_DUE_WIDGET_RESULTS';
export const SET_FLOWS_DUE_WIDGET_LOADING = 'SET_FLOWS_DUE_WIDGET_LOADING';
